import PropTypes from 'prop-types'
import React from 'react'

type Auth2State = {
  siteId?: string | number
  memberId?: string
}

const Auth2Context = React.createContext<Auth2State>({})
export const useAuth2 = () => React.useContext(Auth2Context)

const parseSiteId = (siteId: number | string): number | string => {
  switch (siteId) {
    case '1':
      return 1
    case '2':
      return 2
    case '3':
      return 3
    case '4':
      return 4
    case '7':
      return 7
    case '66':
      return 66
    case '69':
      return 69
    case '70':
      return 70
    case '71':
      return 71
    case '73':
      return 73
    case '76':
      return 76
    case '105':
      return 105
    default:
      // eslint-disable-next-line no-console
      console.warn('unrecognized siteId:', siteId)
      return siteId
  }
}

type Props = {
  children: React.ReactNode
  member?: {
    siteId?: string | number
    memberId?: string
  }
}

export const Auth2 = ({ children, member }: Props) => {
  const value = {
    ...member,
    siteId: parseSiteId(member?.siteId),
  }
  return <Auth2Context.Provider value={value}>{children}</Auth2Context.Provider>
}
Auth2.propTypes = {
  children: PropTypes.node.isRequired,
  member: PropTypes.shape({
    siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
}
